import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=2cb344fa&"
import script from "./VHeader.vue?vue&type=script&lang=js&"
export * from "./VHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserDropdown: require('/var/www/web1/htdocs/kundenlogin/components/UserDropdown.vue').default})
